import { render, staticRenderFns } from "./help-menu.vue?vue&type=template&id=24427a60&scoped=true&"
import script from "./help-menu.vue?vue&type=script&lang=js&"
export * from "./help-menu.vue?vue&type=script&lang=js&"
import style0 from "./help-menu.vue?vue&type=style&index=0&id=24427a60&scoped=true&lang=css&"
import style1 from "./help-menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24427a60",
  null
  
)

export default component.exports